import Logo from 'common/Components/Logo';
import Layout from 'common/Layouts';
import { Form } from './Components/Form';

export const DesktopForceChangePassword = () => {


  return (
    <Layout title="انقضای رمز عبور - رامند تریدر">
      <div className="mt-1">
        <Logo />
        <h1 className='text-4xl xl:text-5xl !font-bold text-center mt-5 text-L-primary-50'>انقضای رمز عبور</h1>
        <h1 className="text-3xl xl:text-4xl !font-medium text-center mt-5 mb-52 !leading-8">
          توجه: کاربر گرامی، رمز عبور شما منقضی شده است. 
          <br />
          لطفا برای امنیت بیشتر
          نسبت به تغییر رمز عبور خود اقدام قرمایید.
        </h1>
      </div>
      <Form />
    </Layout>
  );
};
